export default {
  shopify: process.env.VUE_APP_SP_API_HOST,
  bigcommerce: process.env.VUE_APP_BC_API_HOST
}
